import log from '../components/log'
import confirm from '@/components/confirm'
import {
  getIndex,
  by,
  getIdArray,
  subArg,
  urlFormat,
  emailValidator,
  percentageFmt,
  isContained,
  generateGuuId,
  clearEmptyParam,
} from '@common/js/common'
import Bitapsearch from '@lib/bitap'
import moment from 'moment'

export default {
  install(Vue, options) {
    Vue.prototype.getIndex = getIndex
    Vue.prototype.by = by
    Vue.prototype.getIdArray = getIdArray
    Vue.prototype.subArg = subArg
    Vue.prototype.urlFormat = urlFormat
    Vue.prototype.emailValidator = emailValidator
    Vue.prototype.percentageFmt = percentageFmt
    Vue.prototype.isContained = isContained
    Vue.prototype.generateGuuId = generateGuuId
    Vue.prototype.clearEmptyParam = clearEmptyParam
    Vue.prototype.bitapsearch = (list, keys) => {
      let options = {
        threshold: 0.2, // 筛选模糊匹配权重 0表示完全匹配
        location: 0, // 匹配起始位置
        distance: 100,
        maxPatternLength: 32, // 最大匹配长度
        minMatchCharLength: 1, // 最小匹配长度
        keys: keys, // 匹配关键字key
      }

      return new Bitapsearch(list, options)
    }

    // 实例方法或对象，在子组件里通过this调用
    Vue.prototype.step = {
      next(vm) {
        vm.steps.current++
      },

      back(vm) {
        vm.steps.current--
      },

      go(vm, to) {
        let current = vm.steps.current
        if (to < current) {
          vm.steps.current = to
        } else if (to > current) {
          for (let i = current; i < to; i++) {
            vm.next()
          }
        }
        // vm.steps.current = to;
      },
    }
    Vue.prototype.aff_permission = {}
    // log窗口
    Vue.prototype.Log = function(obj, event_group, event, search) {
      this.$starfish.dialog.open({
        component: log,
        onClose: data => {},
        closeOnModal: false,
        props: {
          object_id: obj.id,
          object_name: obj.name,
          object_field: obj.object_field,
          model: obj.model,
          event_group: event_group,
          event: event,
          search: search,
          and_or: obj.and_or || 0,
        },
      })
    }
    // 通知窗口
    // 成功通知: notifyOpen()
    // 错误通知: notifyOpen('Error', 'error msg here')
    Vue.prototype.notifyOpen = function(title, msg, type) {
      type = type || (title === 'Error' ? 'error' : 'success')
      msg = msg || (type === 'success' ? 'Success' : 'Error')
      this.$starfish.notify({
        title: title || 'Success',
        message: msg,
        type: type,
        duration: type === 'success' || !type ? 5000 : 10000,
      })
    }
    Vue.prototype.notifyError = function(error, title, msg) {
      let message
      // 提取error信息
      if (error && error.m) {
        message = error.m
      } else if (error && error.message) {
        message = error.message
      } else if (error && error.response) {
        message = error.response.statusText
      } else if (error && typeof error.c === 'string') {
        message = error.c
      }
      this.$starfish.notify({
        title: title || 'Error',
        message: msg || message,
        type: 'error',
        duration: 10000,
      })
    }
    // 确认窗口
    Vue.prototype.confirmOpen = function(callback, cancelCallBack) {
      this.$starfish.dialog.open({
        component: confirm,
        closeOnModal: false,
        onClose: data => {
          if (data && !data.target) {
            callback()
          } else if (cancelCallBack) {
            cancelCallBack()
          }
        },
      })
    }

    /**
     * 判断全局数据列表是否存在
     * @key_list 需要获取数据的key数组[{list_name: '', field_name: ''}]
     *     @list_name 全局列表的名称
     *     @field_name 请求数据的filed名称
     *     @length 初始属性个数
     * @callback 请求数据的全局方法
     * return
     */
    Vue.prototype.isListGet = function(key_list, callback) {
      let get_list_key = []
      let get_setting_field = []
      for (let i = 0, il = key_list.length; i < il; i++) {
        let key = key_list[i]
        let list = this[key.list_name.toLowerCase()]
        if (list && Object.keys(list).length === (key.length || 0)) {
          get_list_key.push(key.list_name)

          if (key.field_name) {
            get_setting_field.push(key.field_name)
          }
        }
      }

      if (!get_list_key.length) {
        return
      }

      let _this = this
      return callback(
        _this,
        get_setting_field.length ? get_setting_field.join(',') : undefined
      ).then(data => {
        for (let i = 0, il = get_list_key.length; i < il; i++) {
          this.$store.commit(get_list_key[i], data)
        }
        return data
      })
    }
    // 改变翻页参数
    Vue.prototype.changePageItem = function(page, data) {
      page.tot = data.tot
      page.cur = data.p
      page.per = data.n
    }
    // 获取评估原因列表
    Vue.prototype.getEvaluateReason = function(_this) {
      let $this = _this || this
      return $this.$http.get('/api/data/evaluate-reason/', {}).then(data => {
        return data
      })
    }
    // 获取时区列表
    Vue.prototype.getTimezone = function() {
      return this.$http.get('/api/data/timezones/').then(data => {
        for (let item of data.data) {
          item.label = item.gmt + ' ' + item.location
        }
        return data.data
      })
    }
    // 另一版的时区列表，id为offset
    Vue.prototype.getTZlist = function() {
      return this.$http.get('/api/data/timezones-v2/').then(data => {
        for (let item of data.data) {
          item.label = item.gmt + ' ' + item.location
        }
        return data.data
      })
    }
    // 获取国家列表
    Vue.prototype.getCountries = function() {
      return this.$http.get('/api/data/countries/').then(data => {
        for (let item of data.data) {
          item.label = item.code + '-' + item.name
        }
        // data.data.push({
        //   code: 'global',
        //   name: 'global',
        //   label: 'Global',
        // })
        return data.data
      })
    }
    // 获取国家列表, 无global
    Vue.prototype.getCountry = function() {
      return this.$http.get('/api/data/countries/').then(data => {
        for (let item of data.data) {
          item.label = item.code + '-' + item.name
        }
        return data.data
      })
    }
    Vue.prototype.filterCountry = function(query, item) {
      let code = item.code + item.name || item.code || item.value || ''
      return code.toLowerCase().indexOf(query.toLowerCase()) !== -1
    }
    // 获取运营商列表
    Vue.prototype.getCarriers = function(_this) {
      let $this = _this || this
      return $this.$http.get('/api/data/carriers/').then(data => {
        let result = []
        let result_obj = {}
        for (let index in data) {
          let list = data[index]
          for (let i = 0, il = list.length; i < il; i++) {
            let name = list[i].name
            if (!result_obj[name]) {
              result.push(list[i])
              result_obj[name] = 1
            }
          }
        }
        return {
          carriers: data,
          all_carriers: result,
        }
      })
    }
    // 获取JsCategory列表
    Vue.prototype.getJsCategorys = function() {
      return this.$http.get('/api/data/js-category/').then(data => {
        return data.data
      })
    }
    // 获取公共数据
    Vue.prototype.getSettingData = function(_this, fields) {
      return _this.$http
        .get('/api/data/settings/', {
          params: {
            fields: fields,
          },
        })
        .then(data => {
          return data.data
        })
    }
    // 获取用户列表
    Vue.prototype.getUserList = function(role, search) {
      return this.$http
        .get('/api/users/', {
          params: {
            role: role || 0,
            status: 1,
            fields: 'id,name,email',
            is_paginate: 0,
            search: search || '',
          },
        })
        .then(data => {
          for (let item of data.data) {
            item.name_email = item.name + '(' + item.email + ')'
          }
          return data.data
        })
    }
    // 获取用户的权限列表
    Vue.prototype.getPermission = function(fields) {
      return this.$http.get(`/api/data/permissions/?fields=${fields}`).then(res => {
        return res.data
      })
    }
    // 获取AM列表
    Vue.prototype.getAMlist = function(params, search) {
      let role = JSON.parse(this.LS.get('ROLE'))
      let am_role = params ? params.am_role : role.am_role

      return this.$http
        .get('/api/users/', {
          params: {
            role: am_role,
            status: 1,
            fields: 'id,name,email',
            is_paginate: 0,
            search: search || '',
          },
        })
        .then(data => {
          for (let item of data.data) {
            item.name_email = item.name + '(' + item.email + ')'
          }
          return data.data
        })
    }
    // 获取PM列表
    Vue.prototype.getPMlist = function(params, search) {
      let role = JSON.parse(this.LS.get('ROLE'))
      let ad_op_role = params ? params.ad_op_role : role.ad_op_role

      return this.$http
        .get('/api/users/', {
          params: {
            role: ad_op_role,
            status: 1,
            fields: 'id,name,email',
            is_paginate: 0,
            search: search || '',
          },
        })
        .then(data => {
          for (let item of data.data) {
            item.name_email = item.name + '(' + item.email + ')'
          }
          return data.data
        })
    }
    // 获取TD列表
    Vue.prototype.getTDlist = function(params, search) {
      let role = JSON.parse(this.LS.get('ROLE'))
      let td_role = params ? params.td_role : role.td_role

      return this.$http
        .get('/api/users/', {
          params: {
            role: td_role,
            status: 1,
            fields: 'id,name,email',
            is_paginate: 0,
            search: search || '',
          },
        })
        .then(data => {
          for (let item of data.data) {
            item.name_email = item.name + '(' + item.email + ')'
          }
          return data.data
        })
    }
    // 获取渠道列表
    Vue.prototype.getAffList = function(fields, params) {
      return this.$http
        .get('/api/affiliates/', {
          params: {
            fields: fields,
            ...params,
          },
        })
        .then(res => {
          let data = res.data
          for (let i = 0, il = data.length; i < il; i++) {
            let item = data[i]
            item.label = `${item.id}:${item.company}`
          }
          return data
        })
    }
    // 获取子渠道列表
    Vue.prototype.getChannelList = function(fields, params) {
      return this.$http
        .get('/api/affiliates/channels/', {
          params: {
            fields: fields || 'id,name',
            n: 500,
            ...params,
          },
        })
        .then(res => {
          let data = res.data
          for (let i = 0, il = data.length; i < il; i++) {
            let item = data[i]
            item.label = `${item.id}:${item.name}`
          }
          return data
        })
    }
    // 获取广告主列表
    Vue.prototype.getAderList = function(fields, params, format_name) {
      return this.$http
        .get('/api/aders/', {
          params: {
            fields: fields || 'id,short_name',
            ...params,
          },
        })
        .then(res => {
          let data = res.data
          for (let i = 0, il = data.length; i < il; i++) {
            let item = data[i]
            item.name = format_name ? `${item.id}:${item.short_name}` : item.short_name
          }
          return data
        })
    }
    // 获取API广告主列表
    Vue.prototype.getApiAderList = function(fields, params, format_name) {
      return this.$http
        .get('/api/aders/api/', {
          params: {
            fields: fields || 'id,name',
            ...params,
          },
        })
        .then(res => {
          let data = res.data
          for (let i = 0; i < data.length; i++) {
            let item = data[i]
            item.name = format_name ? `${item.id}:${item.name}` : item.name
          }
          return data
        })
    }
    // 获取offer列表
    Vue.prototype.getOfferList = function(fields, params) {
      return this.$http
        .get('/api/offers/', {
          params: {
            fields: fields,
            ...params,
          },
        })
        .then(res => {
          let data = res.data
          for (let i = 0, il = data.length; i < il; i++) {
            let item = data[i]
            item.label = `${item.oid}:${item.name}`
          }
          return data
        })
    }
    // 获取ASO offer列表
    Vue.prototype.getAsoOfferList = function(fields, params) {
      return this.$http
        .get('/api/offers/aso/list/', {
          params: {
            fields: fields || 'id,name',
            ...params,
          },
        })
        .then(res => {
          let data = res.data
          for (let i = 0; i < data.length; i++) {
            let item = data[i]
            item.label = `${item.id}:${item.name}`
          }
          return data
        })
    }
    // 获取smartlink列表
    Vue.prototype.getSmartlinkList = function(fields, params) {
      return this.$http
        .get('/api/offers/smart-link/', {
          params: {
            fields: fields,
            ...params,
          },
        })
        .then(res => {
          let data = res.data
          for (let i = 0, il = data.length; i < il; i++) {
            let item = data[i]
            item.label = `${item.gid}:${item.name}`
          }
          return data
        })
    }

    // 获取广告主对接模板列表
    Vue.prototype.getAdapters = function(fields, params) {
      return this.$http
        .get('/api/aders/adapter/get/', {
          params: {
            fields: fields,
            ...params,
          },
        })
        .then(res => {
          let data = res.data
          for (let i = 0, il = data.length; i < il; i++) {
            let item = data[i]
            item.label = `${item.campaign_name}`
          }
          return data
        })
    }

    // 获取广告主对接模板列表
    Vue.prototype.getAsoAders = function(fields, params) {
      return this.$http
        .get('/api/autoaders/ader_infos/', {
          params: {
            search: fields.search,
            ...params,
          },
        })
        .then(res => {
          let data = res.data
          return data
        })
    }

    Vue.prototype.getSmlList = function(fields, params) {
      return this.$http
        .get('/api/offers/smart-link/', {
          params: {
            fields: fields || 'gid,name',
            ...params,
          },
        })
        .then(res => {
          this.sml_list = res.data
          return res
        })
    }

    // 获取Appname列表
    Vue.prototype.getAppnameList = function(fields, params) {
      return this.$http
        .get('/api/settings/app-name/', {
          params: {
            fields: fields,
            ...params,
          },
        })
        .then(res => res)
    }

    // 获取Carrier别名列表
    Vue.prototype.getCarrierList = function(fields, params) {
      return this.$http
        .get('/api/settings/carrier-list/', {
          params: {
            fields: fields || 'carrier',
            ...params,
          },
        })
        .then(res => {
          let data = res.data
          for (let i = 0, il = data.length; i < il; i++) {
            let item = data[i]
            item.label = `${item.carrier}`
          }
          return data
        })
    }
    // 返回标签类型
    Vue.prototype.setTagType = function(value) {
      let type = 'info'
      switch (value) {
        case 0:
          type = 'info'
          break
        case 1:
          type = 'success'
          break
        case 2:
          type = 'warning'
          break
        case 3:
          type = 'default'
          break
      }
      return type
    }
    // 返回文字类型
    Vue.prototype.setTextType = function(value) {
      let type = 'info'
      switch (value) {
        case 0:
          type = 'info'
          break
        case 1:
          type = 'success'
          break
        case 2:
          type = 'error'
          break
        case 3:
          type = 'cancel'
          break
        case 4:
          type = 'cancel'
          break
      }
      return type
    }
    // 保存原始数据
    Vue.prototype.setOrigin = function(parent, data) {
      let { origin, ...new_origin } = { ...data }

      // origin中有复杂数据结构的，析构后仍指向同一个地址。因此需使用json转化。
      parent.origin = JSON.parse(JSON.stringify(new_origin))
    }
    // 重置数据
    Vue.prototype.resetData = function(key, item, parent) {
      let { ...origin } = { ...item.origin }
      parent = parent || this
      parent[key] = item.origin
      parent[key].origin = JSON.parse(JSON.stringify(origin))
    }
    // 输入数据为数字的表单验证规则
    Vue.prototype.numberRules = function(prop, params, errMsg, otherErrMsg) {
      params = params || {}
      let rules = {}
      let float = params.float || false
      let min = params.min || 0
      let max = params.max
      let required = params.required === undefined ? true : params.required

      for (let i = 0, il = prop.length; i < il; i++) {
        rules[prop[i]] = [
          {
            validator: (rule, value, callback) => {
              let data = Number(value)
              if (!value && value !== 0) {
                // 为空不为0
                if (required) {
                  callback(new Error(errMsg || 'Can\'t be empty!'))
                } else {
                  callback()
                }
              } else if (isNaN(data)) {
                // 非数字
                callback(new Error(errMsg || `${value} is not a number!`))
              } else if (!Number.isInteger(data) && !float) {
                // 非整数
                callback(new Error(errMsg || `${value} is not a integer!`))
              } else if (data < min) {
                // 最小值
                callback(new Error(otherErrMsg || errMsg || `Can't be less than ${min}`))
              } else if (max && data > max) {
                // 最大值
                callback(new Error(otherErrMsg || errMsg || `Can't be more than ${max}`))
              } else if (float) {
                // 保留两位小数
                let float_data = String(data).split('.')[1]
                if (float_data && float_data.length > 2) {
                  callback(new Error(otherErrMsg || errMsg || 'Please keep two decimal places.'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
          },
        ]
      }
      return rules
    }
    // 全局事件总线，可以用于非父子组件之间的通信
    Vue.prototype.$bus = new Vue()

    // 判断是否已经选中了所有项
    Vue.prototype.isSelectedAll = function(selected, list) {
      return selected.length === list.length
    }

    Vue.prototype.isNegative = function(e) {
      if (e.key === '-') {
        e.preventDefault()
      }
    }
    // 强制要求正整数
    Vue.prototype.isInteger = function(e) {
      if (e.key < '0' || e.key > '9') {
        e.preventDefault()
      }
    }
    // 切割大文件，分片上传
    Vue.prototype.splitFile = function(file) {
      // 分片，每片大小为5M
      let chunkSize = 5 * 1024 * 1024
      let count = Math.ceil(file.size / chunkSize)
      let chunkArr = []
      for (let i = 0; i < count; i++) {
        chunkArr.push({
          order: i,
          name: file.name,
          chunk: new File([file.slice(i * chunkSize, (i + 1) * chunkSize)], file.name, {
            type: file.type,
          }),
        })
      }
      return chunkArr
    }

    Vue.prototype.setTitle = function(title) {
      document.title = title ? `${title}` : 'Report | Demeter'
    }

    Vue.prototype.formatEmptyString = function(obj) {
      let ks = Object.keys(obj)
      ks.forEach(function(k) {
        if (obj[k] === '') {
          obj[k] = undefined
        }
      })
      return obj
    }

    // 省略过长字符串中间部分
    Vue.prototype.stringEllipsis = function(str) {
      if (str.length > 15) {
        return str.substring(0, 9) + '...' + str.substring(str.length - 6, str.length)
      } else {
        return str
      }
    }

    // 计算时间字符串和当前时间的差值
    Vue.prototype.timeDiff = function(time) {
      let dateBegin = new Date(time.replace(/-/g, '/'))
      let dateEnd = new Date()
      let dateDiff = dateEnd.getTime() - dateBegin.getTime()
      let days = Math.floor(dateDiff / (24 * 3600 * 1000))
      let leave1 = dateDiff % (24 * 3600 * 1000)
      let hours = Math.floor(leave1 / (3600 * 1000))
      let leave2 = leave1 % (3600 * 1000)
      let minutes = Math.floor(leave2 / (60 * 1000))
      if (days > 0) {
        return `${days}days`
      }
      if (days === 0 && hours > 0) {
        return `${hours}hours`
      }
      if (days === 0 && hours === 0) {
        return `${minutes}minutes`
      }
    }

    // 格式化日期
    Vue.prototype.formatDate = function(date, format) {
      let dateStr = ''
      format = format || 'YYYY-MM-DD'
      if (date) {
        dateStr = moment(date).format(format)
      }
      return dateStr
    }

    Vue.prototype.formatNum = function(num) {
      if (num) {
        let integer = String(num).split('.')[0]
        let decimal = String(num).split('.')[1]
        if (decimal) {
          num = integer + '.' + decimal.substr(0, 2)
        }
      }
      return num
    }
  },
}
